var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud',{attrs:{"action-icon":_vm.actionIcon,"model-def":_vm.modelDef,"action-position":_vm.actionPosition,"speed-dial-options":_vm.speedDialOptions,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }